<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title">FOREWORD</p>
<p class="noindent2">Staten Island is rich in history. A permanent settlement took place in 1661. Before that, the Lenape lived and prospered on the island. The island has also been known for the mix of ethnic groups and individuals who have settled therein. For these reasons and others, there are factual stories and fanciful tales of spirits and specters to interest those of a historical mind. Author, historian and educator Marianna Randazzo has once again filled the needs of those seeking knowledge. In <i>Haunted Staten Island</i>, she has woven paranormal tales with historical events. Many are new; others are as old as the lanes and byways of the borough. In fact, this new book takes up where Charles Hines and William T. Davis left off with <i>Legends, Stories, and Folklore of Old Staten Island</i>. Published in 1925, this missive focused on the north shore and wove together both tales and bits and pieces of the interesting, strange and peculiar. Some came down through the years by word of mouth, others in written form. Ms. Randazzo has done much the same but has brought us nearly up to date on uncanny and intriguing topics. Readers will enjoy this mystical walk through Staten Island history.</p>
<p class="right1">Patricia Salmon</p>
<p class="right">author, historian</p>
<p class="right"><a href="http://www.patsalmonhistory.com" target="_blank">www.patsalmonhistory.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?b6b821ee